import Vue from "vue";
import Page from "./index.vue";
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload);
new Vue({ render: (h) => h(Page) }).$mount("#app");
